export default "__VITE_ASSET__$dFdo_Yl__"